import React from "react";
import { motion } from "framer-motion";
import kebun from "../../img/icon-kebun.png";
import logistik from "../../img/icon-logistic.png";
import pabrik from "../../img/icon-pabrik.png";

const stakeholderData = [
    {
      img: kebun,
      title: "Petani",
      desc: `Stakeholder petani bagian pertama dalam proses ketertelusuran 
  bahan baku singkong. Mulai dari memanen Singkong hingga mengirim 
  produk tersebut ke stakeholder logistik.`,
    },
    {
      img: logistik,
      title: "Logistik",
      desc: `Stakeholder logistik menjadi garda terdepan untuk 
  mengirimkan produk singkong ke pabrik untuk diolah.`,
    },
    {
      img: pabrik,
      title: "Pabrik",
      desc: `Stakeholder pabrik mengolah singkong melalui beberapa 
  station pemeriksaan kualitas singkong, termasuk kebersihan, 
  kematangan, ketidakcacatan, dan lain lain.`,
    },
  ];
  

const cardVariant = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      delay: i * 0.3,
    },
  }),
};

const StakeholderSection = () => {
  return (
    <section id="stakeholder">
      <div id="stake-holder" className="row">
        <div>
          <h2 className="text-center pb-3">
            <strong id="stakeholders">Stakeholder</strong>
          </h2>
        </div>
        <div className="row text-center">
          {stakeholderData.map((item, i) => (
            <motion.div
              className="col-md"
              key={i}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false }}
              variants={cardVariant}
            >
              <div className="row justify-content-center">
                <div className="icon-stakeholder">
                  <img src={item.img} alt={item.title} className="img-fluid" />
                </div>
              </div>
              <div className="text-stakeholder">
                <h3>
                  <strong>{item.title}</strong>
                </h3>
              </div>
              <div className="p-stakeholder">
                <p>{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StakeholderSection;
